//Dependencies
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
//Pages
import InfoPage from './assets/modules/pages/InfoPage';
import NotFoundPage from './assets/modules/pages/NotFoundPage';
//Routers
import MainRouter from './assets/modules/routers/MainRouter';
//CSS
import './assets/css/input.css';
import 'leaflet/dist/leaflet.css';
import 'antd/dist/antd.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route
          exact
          path    = '/404'
          element = {<NotFoundPage />}
        />

        <Route
          exact
          path    = '/'
          element = {<MainRouter />}
        />

        <Route
          exact
          path    = '/info'
          element = {<InfoPage />}
        />

        <Route
          exact
          path    = '/:id'
          element = {<MainRouter />}
        />
        
        <Route 
          path = "*" 
          component = 
          {
            () => <NotFoundPage/>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
